import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramReportPrevAnswer on MostRecentAssessmentAnswerNode {
    questionId
    questionType
    integerAnswer
    submitted
  }

  query getAssessmentMostRecentAnswers($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      performanceReportRows {
        edges {
          node {
            id
            user {
              id
            }
            assessment {
              id
              mostRecentAnswers {
                ...ComplianceProgramReportPrevAnswer
              }
            }
          }
        }
      }
    }
  }
`;
